import Cookies from "../helper/cookies";

let available_languages = ['de', 'en'];
let language = Cookies.get("language");

if (!available_languages.includes(language)) {
    language = 'en';
}

export default {
    parseReference: function (text) {
        if (text.includes('@ref:')) {
            const reference = text.replace(/@ref:/g, '');
            const path = reference.split('.');
            let obj = this;
            for (let i = 0; i < path.length; i++) {
                if (typeof obj === "object" && Object.keys(obj).includes(path[i])) {
                    obj = obj[path[i]]
                }
            }
            if (typeof obj === "string") {
                return obj;
            }
        }
        return text;
    },
    affiliate: require("./" + language + "/affiliate.json"),
    buttons: require("./" + language + "/buttons.json"),
    comments: require("./" + language + "/comments.json"),
    charts: require("./" + language + "/charts.json"),
    dashboard: require("./" + language + "/dashboard.json"),
    detail: require("./" + language + "/detail.json"),
    footer: require("./" + language + "/footer.json"),
    general: require("./" + language + "/general.json"),
    login: require("./" + language + "/login.json"),
    register: require('./' + language + '/register.json'),
    membership: require("./" + language + "/membership.json"),
    navigation: require("./" + language + "/navigation.json"),
    profile: require("./" + language + "/profile.json"),
    searchStocks: require("./" + language + "/searchStocks.json"),
    watchlist: require("./" + language + "/watchlist.json"),
    news: require("./" + language + "/news.json"),
    testaccount: require("./" + language + "/testaccount.json"),
    market: require("./" + language + "/market.json"),
    quality: require("./" + language + "/quality.json"),
    newsfeed: require("./" + language + "/newsfeed.json"),
    fairvalueChart: require("./" + language + "/fairvalueChart.json"),
    cookieBanner: require("./" + language + "/cookieBanner.json"),
    sector: require("./" + language + "/sector.json"),
    screener: require("./" + language + "/screener.json"),
    stock: require("./" + language + "/stock.json"),

    // Only EN
    ismystockgood: require("./en/ismystockgood.json"),

}